import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { ConfettiMinimalisticIcon, FullscreenAlert } from "@/shared/ui";

export const CoachingSuccessScreenAlert = () => {
  return (
    <FullscreenAlert.Root open={true}>
      <FullscreenAlert.Content>
        <FullscreenAlert.Header icon={ConfettiMinimalisticIcon}>
          <FullscreenAlert.Title>
            {t`You're now part of the LevelsRx Coaching crew!`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Congratulations! We're thrilled to support you on your wellness journey.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action asChild>
            <Link to={ROUTES.COACHING.OVERVIEW}>
              {t`Explore Coaching sessions`}
            </Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
